import React, { useState, useEffect } from "react";
import { CountryService } from "../../services/CountryService";
import DiplomaticDirectoryTable from "../Common/DiplomaticDirectoryTable";
import { Divider } from "primereact/divider";
import { AddPageHeader } from "../Common/Utils";
import { Link } from "react-router-dom";

const DiplomaticDirectory = () => {
  const [diplomaticDirectory, setDiplomaticDirectory] = useState([]);
  const countryService = new CountryService();

  useEffect(() => {
    countryService
      .getDiplomaticDirectory()
      .then((data) => setDiplomaticDirectory(data));
  }, []);

  return (
    <div className="reduce-width">
      {AddPageHeader("Diplomatic directory")}
      <Divider align="center">
        <h1>Diplomatic directory</h1>
      </Divider>
      <div className="privacy-terms">
        The diplomatic directory lists websites and social media accounts of
        worldwide entities in charge of foreign affairs. Are you a governmental
        body? Interested in updating the directory? Please feel free to{" "}
        <Link
          to="/contact"
          style={{
            color: "black",
            fontWeight: "bold",
          }}
        >
          contact
        </Link>{" "}
        the Center.
      </div>
      <DiplomaticDirectoryTable
        data={diplomaticDirectory}
        searchEnabled
        longDescription
      />
    </div>
  );
};

export default DiplomaticDirectory;
